import type { FaireProductEntity } from "../../entity_types/product";

export const p_d3ama7c5rm: FaireProductEntity = {
  token: "p_d3ama7c5rm",
  type: "product",
  name: "LDC Vibrant Striped Detail Athleisure 2pcs Short Set",
  brandToken: "b_pzbv7m48pw",
  brandName: "Little Daisy Closet",
  imageUrl:
    "https://cdn.faire.com/fastly/da240549ef8f436e393bf7dfd0e770f344505c45987db52c064dc5076848e85f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e42988a02d20f6624837c130a745a4fc25cc37b2ae0fd10c4b76a77fc4667eb3.png",
    "https://cdn.faire.com/fastly/209edfc266047007df6c35d9fd809e44a5f9aa30ebc1e6807f6c537b0943788f.png",
    "https://cdn.faire.com/fastly/0b60bdba9f913d733b2af0d07d4212f2739ddbbde3d13ff363cb0779e0951178.png",
    "https://cdn.faire.com/fastly/896d74d7334d07ac72e1cd18268afcc303d6c85f7b289af9c4151c75a9976e88.png",
    "https://cdn.faire.com/fastly/0d1b0693f7527f82002a0171f601eb6aa5234d4a1b43e45c2e3fdfb317a923b3.png",
    "https://cdn.faire.com/fastly/400ef4fde2eda06ec35ff70a2f6fc33355bb78601fed4b559f3161f9bdf433a5.png",
    "https://cdn.faire.com/fastly/554461b22e08ab7344412134c3ffdddbecd216f25494ce29dbe09716cf50d5ae.png",
  ],
  priceDollars: 22,
  description:
    "item LDC Vibrant Striped Detail Athleisure 2pcs Short Set\nMaterial 85%Polyester+10%Cotton+5%Elastane\nStyle  Casual\nPattern   Striped \nOccasion   Daily\nSeason S/S \n\n👚 Y2K-inspired short set instantly upgrades your off-duty style.  \n🩳 Comes with a relaxed tee and matching athleisure shorts.  \n🧵 Soft, stretchy fabric keeps you comfy all day long.  \n🛍️ Ideal for lounging, errands, and casual hangouts.\n\nWe offer personalized woven labels and tags. If you're interested in this service, please contact us to learn more details.",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:39.955Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
